// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

import { type SafeJsonRpcClient } from '@safecoin/safe/jsonRpc';
import { useQuery } from '@tanstack/react-query';

import { useEnhancedRpcClient } from '~/hooks/useEnhancedRpc';

export function useGetAllEpochAddressMetrics(
	...input: Parameters<SafeJsonRpcClient['getAllEpochAddressMetrics']>
) {
	// safex_getAllEpochAddressMetrics is served by the indexer (/indexer), not the fullnode.
	const client = useEnhancedRpcClient();
	return useQuery({
		queryKey: ['get', 'all', 'epoch', 'addresses', ...input],
		queryFn: () => client.getAllEpochAddressMetrics(...input),
		// Historical per-epoch series (heavy query, changes per-epoch): refresh every 60s.
		staleTime: 60 * 1000,
		refetchInterval: 60 * 1000,
	});
}
